import { USER_ACHIEVEMENTS } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { ERROR_CODES } from "@/libs/error/types";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { UserAchievements } from "../types";
import { getUserAchievementsApi } from "../services";

const useUserAchievements = (swooshHandle: string) => {
  const { isLoading, error, data } = useQuery<
    UserAchievements,
    AxiosError,
    UserAchievements
  >(
    [USER_ACHIEVEMENTS, swooshHandle],
    async () => await getUserAchievementsApi(swooshHandle),
    {
      retry: false,
      enabled: !!swooshHandle,
      useErrorBoundary: ({ response }) =>
        response !== undefined &&
        (response.status >= ERROR_CODES.INTERNAL_ERROR ||
          response.status === ERROR_CODES.BAD_REQUEST ||
          response.status === ERROR_CODES.NOT_FOUND),
    },
  );

  return { isLoading, error, data };
};

export default useUserAchievements;
